import axios from "axios";
import URLPage from "../endPoints/endpoints";

function  deleteVan (uid, token) {

return axios.delete(`${URLPage}/api/van/${uid}`, {
        headers: {
            'x-token': token
        }
    })
   
 

}

export default deleteVan